<script>
import {useDeviceTypesStore} from "@/stores/deviceTypes.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterDeviceTypesTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useDeviceTypesStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.deviceTypesStore.indexDeviceTypeOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Device Types</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="deviceType in deviceTypesStore.getDeviceTypeOptions"
        v-bind="$attrs"
        :value="deviceType.id"
        :label="deviceType.name"
    />
  </div>
</template>

<style scoped>

</style>